import estilos from '../DetalleSolicitudDeEntrega/DetalleDeEntregaComponent.module.css'
import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import BotonDescargarArchivosComponent from './BotonDescargarArchivosComponent';
import { obtenerTodosCatalogoMaguey } from '../../../../redux/DuckPanelHologramas/ModuloEntregasDuck';
import moment from 'moment'
import { OutlinedInput, InputLabel, MenuItem, Select, FormControl } from "@mui/material";

const InformacionDeSolicitudComponent = (props) => {
    const data = props?.data
    const { api = undefined } = props
    const { handdleEditProductosPrev, productos } = api

    const dispatch = useDispatch()
    const detalleEntrega = useSelector(store => store.ModuloEntregas.detalleEntrega)
    const catalogoMagueyAgave = useSelector(store => store.ModuloEntregas.catalogoMaguey)

    const fechaHoy = moment(detalleEntrega?.fechasolicitud,'YYYY-MM-DD').format('DD/MM/YYYY') 

    const [categoria, setCategoria] = React.useState('')
    const [clase, setClase] = React.useState('')
    const [estado, setEstado] = React.useState('')
    const [magueyesSeleccionados, setMagueyesSeleccionados] = useState([]);
    const [destino, setDestino] = React.useState('')

    const categorias = ["Mezcal", "Mezcal artesanal", "Mezcal ancestral"];
    const clases = ["Joven o blanco", "Madurado en vidrio", "Reposado", "Añejo", "Abocado con", "Destilado con"];
    const estados = ["Oaxaca", "Puebla", "Guerrero", "San Luis Potosí", "Tamaulipas", "Michoacán", "Durango", "Zacatecas", "Guanajuato"];
    const destinos = ["Nacional", "Exportación"];

    React.useEffect(async () => {
        await dispatch(obtenerTodosCatalogoMaguey())
    }, [])

    const [bandera, setBandera] = useState(false);
    React.useEffect(async () => {
        if (props?.infoproducto?.length > 0) {
            setCategoria(props?.infoproducto?.[0]?.categoria)
            setClase(props?.infoproducto?.[0]?.clase)
            setEstado(props?.infoproducto?.[0]?.estado)
            setDestino(props?.infoproducto?.[0]?.destino)
            if (bandera == false) {
                let magueyes = []
                for (const i in props?.infoproducto?.[0]?.magueyesinfoproductohologramas) {
                    magueyes.push(props?.infoproducto?.[0]?.magueyesinfoproductohologramas?.[i].idmaguey)
                }
                setMagueyesSeleccionados(magueyes)
            }
            setBandera(true)
        }
    }, [props])

    return (
        <fieldset className={`${estilos.contenedor} mt-2 row `}>
            <legend className="float-none w-auto text-start"> Información de solicitud </legend>
            <div className="col-md-4"></div>
            <div className="col-md-4 text-end"><label><b>Núm. de solicitud: </b> {detalleEntrega?.informacionmodalaceptada?.numerosolicitudservicios} </label> </div>
            <div className="col-md-4 text-end"><label><b>Fecha solicitud: </b> {fechaHoy} </label></div>

            <div className="col-md-3 mt-5 text-start"><label><b>Núm. de asociado: </b> {detalleEntrega.numerocliente} </label> </div>
            <div className="col-md-9 mt-5 text-start"><label><b>Marca: </b> {data.marca} </label></div>
            <div className="col-md-3 mt-4 text-start" style={{ display: data?.numerolotegranel ? 'block' : 'none' }}><label><b>Lote a granel: </b> {data?.numerolotegranel} </label></div>
            <div className="col-md-3 mt-4 text-start"><label><b>Lote envasado: </b> {data.numerolote} </label></div>
            <div className="col-md-3 mt-4 text-start"><label><b>Núm. de botellas: </b> {data?.numerobotellas} </label></div>
            <div className="col-md-3 mt-4 text-start"><label><b>Inventario: </b>
                {props?.formato == 'FC_09' ? detalleEntrega?.login?.cliente?.[0].inventarioclientehologramas?.[0].hologramasmezcal
                    : props?.formato == 'FC_33' ? detalleEntrega?.login?.cliente?.[0].inventarioclientehologramas?.[0].hologramasmezcal :
                        props?.formato == 'FC_41' ? detalleEntrega?.login?.cliente?.[0].inventarioclientehologramas?.[0].hologramasbebidas :
                            '0'}
            </label></div>
            <div className="col-md-6 mt-4 text-start"><label><b>Análisis: </b>
                {props?.formato == 'FC_09' ? data.numeroanalisis
                    : props?.formato == 'FC_33' ? data.numeroanalisis :
                        props?.formato == 'FC_41' ? data.numeroanalisisgranel :
                            '---'}

            </label></div>
            <div className="col-md-6 mt-4 text-start">
                <strong>Archivos de producto: </strong>
                {props?.formato == 'FC_09' ? <BotonDescargarArchivosComponent nameTabla={'fc_33archivoproducto'} nameFK={'idfc33_anexoproducto'} idSolicitud={data?.idfc33_anexoproducto} />
                    : props?.formato == 'FC_33' ? <BotonDescargarArchivosComponent nameTabla={'fc_33archivoproducto'} nameFK={'idfc33_anexoproducto'} idSolicitud={data?.idfc33_anexoproducto} /> :
                        props?.formato == 'FC_41' ? <BotonDescargarArchivosComponent nameTabla={'fc_33archivoproducto'} nameFK={'idfc33_anexoproducto'} idSolicitud={data?.idfc33_anexoproducto} /> :
                            '0'}

            </div>
            <div className='col-md-3 mt-4' >
                <FormControl sx={{ width: '100%', mb: 1, mt: 1 }}>
                    <InputLabel style={{ fontFamily: 'Montserrat', fontWeight: 'bold' }} >Categoría</InputLabel>
                    <Select
                        input={<OutlinedInput label="Categoría" />}
                        style={{ fontFamily: 'Montserrat' }}
                        MenuProps={{
                            disableScrollLock: true,
                            sx: {
                                "&& .Mui-selected": {
                                    backgroundColor: "#1967D2",
                                    color: 'white'
                                },
                            }
                        }}
                        value={categoria}
                        onChange={e => {
                            setCategoria(e.target.value)
                            handdleEditProductosPrev({
                                categoria: e.target.value, clase: clase, estado: estado, destino: destino,
                                magueyesSeleccionados: magueyesSeleccionados,
                                idproducto: props?.formato == 'FC_09' ? props?.data?.idfc09_anexoproducto :
                                    props?.formato == 'FC_33' ? props?.data?.idfc33_anexoproducto :
                                        props?.formato == 'FC_41' ? props?.data?.idfc41_anexoproducto : ''
                            })
                        }}>
                        {categorias.map((categoria) => (
                            <MenuItem value={categoria} style={{ fontFamily: 'Montserrat' }}> {categoria} </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className='col-md-3 mt-4' >
                <FormControl sx={{ width: '100%', mb: 1, mt: 1 }}>
                    <InputLabel style={{ fontFamily: 'Montserrat', fontWeight: 'bold' }} >Clase</InputLabel>
                    <Select
                        input={<OutlinedInput label="Clase" />}
                        style={{ fontFamily: 'Montserrat' }}
                        MenuProps={{
                            disableScrollLock: true,
                            sx: {
                                "&& .Mui-selected": {
                                    backgroundColor: "#1967D2",
                                    color: 'white'
                                }
                            }
                        }}
                        value={clase}
                        onChange={e => {
                            setClase(e.target.value),
                                handdleEditProductosPrev({
                                    categoria: categoria, clase: e.target.value, estado: estado, destino: destino,
                                    magueyesSeleccionados: magueyesSeleccionados,
                                    idproducto: props?.formato == 'FC_09' ? props?.data?.idfc09_anexoproducto :
                                        props?.formato == 'FC_33' ? props?.data?.idfc33_anexoproducto :
                                            props?.formato == 'FC_41' ? props?.data?.idfc41_anexoproducto : ''
                                })
                        }}>
                        {clases.map((clase) => (
                            <MenuItem value={clase} style={{ fontFamily: 'Montserrat' }}> {clase} </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className='col-md-6 mt-4'>
                <FormControl sx={{ width: '100%', mb: 1, mt: 1 }}>
                    <InputLabel style={{ fontFamily: 'Montserrat', fontWeight: 'bold' }}>Maguey / Agave</InputLabel>
                    <Select
                        multiple
                        input={<OutlinedInput label="Maguey / Agave" />}
                        style={{ fontFamily: 'Montserrat' }}
                        MenuProps={{
                            disableScrollLock: true,
                            sx: {
                                "&& .Mui-selected": {
                                    backgroundColor: "#1967D2",
                                    color: 'white'
                                }
                            }
                        }}
                        value={magueyesSeleccionados}
                        onChange={(e) => {
                            setMagueyesSeleccionados(e.target.value)
                            handdleEditProductosPrev({
                                categoria: categoria, clase: clase, estado: estado, destino: destino,
                                magueyesSeleccionados: e.target.value,
                                idproducto: props?.formato == 'FC_09' ? props?.data?.idfc09_anexoproducto :
                                    props?.formato == 'FC_33' ? props?.data?.idfc33_anexoproducto :
                                        props?.formato == 'FC_41' ? props?.data?.idfc41_anexoproducto : ''
                            })
                        }}>
                        {catalogoMagueyAgave?.map((opcionMagueyAgave) => (
                            <MenuItem value={opcionMagueyAgave.idmaguey} style={{ fontFamily: 'Montserrat' }} >
                                {opcionMagueyAgave.nombrecomun} / {opcionMagueyAgave.catalogoagavehologramas?.nombrecientifico}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className='col-md-4 mt-4' >
                <FormControl sx={{ width: '100%', mb: 1, mt: 1 }}>
                    <InputLabel style={{ fontFamily: 'Montserrat', fontWeight: 'bold' }} >Estado</InputLabel>
                    <Select
                        input={<OutlinedInput label="Estado" />}
                        style={{ fontFamily: 'Montserrat' }}
                        MenuProps={{
                            disableScrollLock: true,
                            sx: {
                                "&& .Mui-selected": {
                                    backgroundColor: "#1967D2",
                                    color: 'white'
                                }
                            }
                        }}
                        value={estado}
                        onChange={e => {
                            setEstado(e.target.value)
                            handdleEditProductosPrev({
                                categoria: categoria, clase: clase, estado: e.target.value, destino: destino,
                                magueyesSeleccionados: magueyesSeleccionados,
                                idproducto: props?.formato == 'FC_09' ? props?.data?.idfc09_anexoproducto :
                                    props?.formato == 'FC_33' ? props?.data?.idfc33_anexoproducto :
                                        props?.formato == 'FC_41' ? props?.data?.idfc41_anexoproducto : ''
                            })
                        }}>
                        {estados.map((estado) => (
                            <MenuItem value={estado} style={{ fontFamily: 'Montserrat' }}> {estado} </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className='col-md-4 mt-4' >
                <FormControl sx={{ width: '100%', mb: 1, mt: 1 }}>
                    <InputLabel style={{ fontFamily: 'Montserrat', fontWeight: 'bold' }} >Destino</InputLabel>
                    <Select
                        input={<OutlinedInput label="Destino" />}
                        style={{ fontFamily: 'Montserrat' }}
                        MenuProps={{
                            disableScrollLock: true,
                            sx: {
                                "&& .Mui-selected": {
                                    backgroundColor: "#1967D2",
                                    color: 'white'
                                }
                            }
                        }}
                        value={destino}
                        onChange={e => {
                            setDestino(e.target.value)
                            handdleEditProductosPrev({
                                categoria: categoria, clase: clase, estado: estado, destino: e.target.value,
                                magueyesSeleccionados: magueyesSeleccionados,
                                idproducto: props?.formato == 'FC_09' ? props?.data?.idfc09_anexoproducto :
                                    props?.formato == 'FC_33' ? props?.data?.idfc33_anexoproducto :
                                        props?.formato == 'FC_41' ? props?.data?.idfc41_anexoproducto : ''
                            })
                        }}>
                        {destinos.map((destino) => (
                            <MenuItem value={destino} style={{ fontFamily: 'Montserrat' }}> {destino} </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </fieldset>
    );

};

export default withRouter(InformacionDeSolicitudComponent)